import { useLocation, useParams } from 'react-router-dom';
import PageHeader from 'src/components/page-header/page-header';
import Description from 'src/components/description-block/description';
import BackButton from 'src/components/buttons/back-button';
import css from './article.module.scss';
import { useMetaContext } from 'src/hooks/meta-context';
import { GENERAL } from 'src/constants/routes';
import generalBannerSoldier from 'src/assets/general/general-banner-soldier.webp';
import { useGetArticle } from './queries';

export interface Route {
  path: string;
  title: string;
}

export interface ArticleProps {
  route?: Route;
}

export default function Article(props: Readonly<ArticleProps>) {
  const { slug } = useParams();
  const state = useLocation()?.state;
  const { data: article, isPending } = useGetArticle(slug);

  const { updateMetaInfo } = useMetaContext();

  const getSearch = () => {
    const search: { slug?: string; tag?: string } = {};
    if (state?.tag) search.tag = state.tag;
    if (state?.slug) search.slug = state.slug;
    return search;
  };

  article &&
    updateMetaInfo({
      title: GENERAL.meta.title,
      description: GENERAL.meta.description,
      openGraph: {
        title: article.title,
        description: article.description.replace(/<\/?[^>]+(>|$)/g, '').slice(0, 100),
        img: generalBannerSoldier,
        type: 'website'
      }
    });

  const stateRoute = props.route ? [props.route] : [state.pages ?? {}];

  return (
    <main className={css.articlePage}>
      <PageHeader title={article?.title ?? ''} description={''} pages={stateRoute} searchParams={getSearch()} />
      <div className={css.container}>
        {!article && !isPending && <h1 className={css.emptyPlaceholder}>Стаття не знайдена</h1>}
        {article && (
          <div className={css.content}>
            <article>
              <h1 className={css.title}>{article.title}</h1>
              <Description description={article.description} className={css.description} />
            </article>
          </div>
        )}
        <div>
          <BackButton />
        </div>
      </div>
    </main>
  );
}
